// extracted by mini-css-extract-plugin
module.exports = {"Support":"B_Support__uyvtE"};